<template>
  <v-card
    v-bind:class="{ archived: paragraph.archived, hidden: (!viewArchived && paragraph.archived), handle: true }"
    style="margin-bottom:20px;cursor:pointer;background: transparent;border: unset;"
    @mouseover="hovering = true"
    @mouseleave="hovering = false"
    flat
  >
      <div 
        v-if="hovering || viewIdentifiers"
        style="position: absolute; right: 0; top: 0; z-index: 5; background: rgba(0,0,0,0.05); padding: 5px; border-bottom-left-radius: 5px; border-top-right-radius: 5px;"
      >
        <span
          v-if="viewIdentifiers"
          style="padding-right:10px;font-family:monospace;font-size:10px"
        >
          P-{{paragraph.id}}
        </span>
        <v-chip 
          outline
          color="grey"
          small
          v-if="conditional_part"  
        >
          Conditional
        </v-chip>
        <v-chip 
          outline
          color="grey"
          small
          v-if="paragraph.web_only"  
        >
          Web Only
        </v-chip>
        <v-chip 
          outline
          color="grey"
          small
          v-if="paragraph.pdf_only"  
        >
          PDF Only
        </v-chip>
        <ArchiveButton
          style="display: inline-block; vertical-align: middle; margin-top: -3px;"
          :archived="paragraph.archived"
          @restore="restore()"
          @archive="archive()"
        />
      </div>
      <div style="position:relative;padding:15px;padding-top:25px;">
        <Preloader v-if="loading"/>
        <div
          class="html"
          v-html="paragraph.text"
        >
        </div>
      </div>
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import Preloader from '@/components/global/Preloader'
import ArchiveButton from './ArchiveButton'

export default {
  name: 'FormTemplateParagraph',
  props: [ 'partId', 'newPart' ],
  components: {
    Preloader,
    ArchiveButton
  },
  data () {
    return {
      loading: false,
      conditional_part: false,
      hovering: false
    }
  },
  created () {
    this.conditional_part = (this.paragraph.conditional_question_id)
  },
  computed: {
    ...mapGetters('formtemplate', [
      'partById'
    ]),
    ...mapState('formtemplate', [
      'viewArchived',
      'viewIdentifiers'
    ]),
    paragraph: function () {
      return this.partById(this.partId) || this.newPart
    },
  },
  methods: {
    ...mapActions('formtemplate', [
      'saveParagraph'
    ]),
    archive () {
      this.loading = true
      this.paragraph.archived = true
      this.saveParagraph(this.paragraph)
      .then(paragraph => {
        this.loading = false
        this.$emit('save', paragraph)
      })
    },
    restore () {
      this.loading = true
      this.paragraph.archived = false
      this.saveParagraph(this.paragraph)
      .then(paragraph => {
        this.loading = false
        this.$emit('save', paragraph)
      })
    }
  }
}
</script>

<style scoped>
  .html >>> p {
    margin: 0 !important;
  }

  .hidden {
    display: none !important;
  }
</style>